/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormTextareaField, {
  FormTextareaFieldProps
} from '../../../../client/js/components/form/fields/FormTextareaField'

function DescriptionField (props: FormTextareaFieldProps) {
  const { name = 'formalDescription', ...others } = props
  const intl = useIntl()
  return (
    <FormTextareaField
      label={intl.formatMessage({
        id: 'formal_description',
        defaultMessage: 'Description formelle'
      })}
      description={intl.formatMessage({
        id: 'formal_description_text',
        defaultMessage: 'Cette description est utilisée uniquement dans le contrat de bail.'
      })}
      name={name}
      parser={upperFirst}
      rows={5}
      {...others}
    />
  )
}

export default DescriptionField
